<!-- 由 woniu6162 创建于 2021-10-19 星期二 -->
<template>
  <div class="track-hot-list">
    <div class="thl_head">
      <img :src="bgPic" class="thl_h_bg" />
      <div class="thl_date" @click="tapOption">
        <div class="thl_d_name">时间</div>
        <div class="thl_d_info">{{ curRange }}</div>
        <i class="iconfont iconxiala" />
      </div>
    </div>
    <div class="thl_body">
      <div class="thl_b_time">更新时间：11:00:00</div>
      <pBox :datum="boxDatum" @viewVideo="viewVideo" />
      <van-empty
        v-if="!boxDatum.length"
        image="search"
        description="暂无数据"
      />
    </div>
    <!-- 时间：选择器 -->
    <van-popup v-model="showTime" position="bottom" round>
      <van-datetime-picker
        v-model="real_date"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="showTime = false"
        @confirm="confirmTime"
      />
    </van-popup>
    <!-- <div
      v-show="curVideo && curVideo != '0'"
      class="thl_video_out"
      @click="curVideo = ''"
    >
      <video
        ref="video"
        class="thl_video"
        :src="curVideo"
        controls
        preload="auto"
        x5-video-player-fullscreen="true"
        webkit-playsinline="true"
        x-webkit-airplay="true"
        playsinline="true"
        x5-playsinline
      ></video>
    </div> -->
  </div>
</template>

<script>
import pBox from './ponents/p-box.vue'
export default {
  name: 'track-hot-list',

  mixins: [],

  components: { pBox },

  props: {},

  data() {
    return {
      showTime: false,
      curTime: new Date(),
      minDate: new Date(2021, 9, 9),
      maxDate: new Date(),
      real_date: new Date(),
      curVideo: '',
      boxDatum: [],
      bgPic: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_bg'
    }
  },

  computed: {
    curRange() {
      let date = this.curTime
        ? this.formatRange(new Date(this.curTime))
        : this.formatRange(new Date())
      return date
    }
  },

  watch: {
    curTime() {
      this.loadDatum()
    }
  },

  created() {},

  mounted() {
    console.log(222)
    this.loadDatum()
  },

  updated() {
    console.log(444)
  },

  destroyed() {},

  methods: {
    loadDatum() {
      this.$toast.loading('加载')
      let params = { date: this.curTime }
      this.$http
        .getApp('member/douyin/billboardSportRank', params)
        .then((rs) => {
          this.$toast.clear()
          if (rs.data.code == 200) {
            this.boxDatum = rs.data.data
          }
        })
        .catch(() => this.$toast.clear())
    },
    // 查看视频
    viewVideo(url) {
      // this.curVideo =
      //   "https://cdnvue.gymcity.com.cn/%E5%81%A5%E8%90%8C%20%E5%8D%97%E4%BA%AC-%E8%8B%8F%E5%AE%81%E6%85%A7%E8%B0%B7%E9%A6%8615s.mp4"
      // this.$nextTick(() => {
      //   this.$refs.video.play()
      // })
      location.href = url
    },
    tapOption() {
      this.showTime = true
    },
    // 确认：时间选择器
    confirmTime(val) {
      this.showTime = false
      this.curTime = this.formatDate(val)
    },
    // 格式化,开始时间：时间选择器
    formatDate(val) {
      var year = val.getFullYear()
      var mon = val.getMonth() + 1
      var date = val.getDate()
      if (mon < 10) mon = '0' + mon
      if (date < 10) date = '0' + date
      var postDate = `${year}/${mon}/${date}`
      return postDate
    },
    // 格式化,月份：显示
    formatRange(val) {
      var year = val.getFullYear()
      var mon = val.getMonth() + 1
      var date = val.getDate()
      if (mon < 10) mon = '0' + mon
      if (date < 10) date = '0' + date
      var postDate = `${year}.${mon}.${date}`
      return postDate
    },
    // 时间选择器：格式化
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      }
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
.track-hot-list {
  min-height: 100vh;
  box-sizing: border-box;
  background: #f7f7f7;
  position: relative;
  .thl_head {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 0;
    .thl_h_bg {
      width: 100%;
      object-fit: cover;
      position: relative;
      z-index: -1;
    }
    .thl_date {
      position: absolute;
      bottom: 5.3vw;
      width: 91.7vw;
      height: 9.9vw;
      padding: 0 5.3vw 0 3.2vw;
      box-sizing: border-box;
      background-color: #f7f7f7;
      border-radius: 1.1vw;
      display: flex;
      align-items: center;
      background: #fff;
      .thl_d_name {
        min-width: fit-content;
        font-size: 3.5vw;
        color: rgba(0, 0, 0, 0.5);
      }
      .thl_d_info {
        text-align: left;
        width: 100%;
        padding-left: 5.3vw;
        font-size: 3.5vw;
        font-weight: 600;
        color: #000;
      }
      & > i {
        font-size: 2.4vw;
        color: #ccc;
      }
    }
  }
  .thl_body {
    position: relative;
    top: -2vw;
    padding: 4.3vw;
    border-radius: 2.7vw 2.7vw 0 0;
    background: #f7f7f7;
    .thl_b_time {
      font-size: 3.2vw;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.5);
    }
  }
  .thl_video_out {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 10;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.85);
    .thl_video {
      width: 100vw;
      height: auto;
    }
  }
}
</style>
